<!-- 脱敏反查通用组件 -->
<template>
  <div class="base-decrypt">
    <span>{{ showData || '--' }}</span>
    <i v-if="data" class="iconfont" :class="isDecrypt ? 'iconxianshimima' : 'iconyincang'" @click="decrypt" />
  </div>
</template>
<script>
import { RESPONSE_CODE } from '@public/http/config'
import { publicApi } from './pool'

export default {
  name: '',
  props: {
    data: {
      type: String,
      default: ''
    },
    params: {
      type: Object,
      default: () => {}
    },
    formatData: {
      type: Function,
      default: () => null
    },
    api: {
      type: Function,
      default: publicApi.decrypt
    }
  },
  data() {
    return {
      loading: false,
      isDecrypt: false,
      decryptData: ''
    }
  },
  computed: {
    showData() {
      return this.isDecrypt ? this.decryptData : this.data
    }
  },
  methods: {
    decrypt() {
      if (this.isDecrypt) {
        this.isDecrypt = false
        this.$emit('onChange', this.data)
        return
      }
      if (this.decryptData) {
        this.isDecrypt = true
        this.$emit('onChange', this.decryptData)
        return
      }
      if (this.loading) return
      this.loading = true
      this.api(this.params).then(({ code, data }) => {
        if (code === RESPONSE_CODE.SUCCESS) {
          this.decryptData = this.formatData(data)
          this.isDecrypt = true
          this.$emit('onChange', this.decryptData)
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .base-decrypt {
    width: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
    span {
      flex-shrink: 1;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .iconfont {
      cursor: pointer;
      margin-left: 3px;
    }
  }
</style>
